import TutorialStep2 from './TutorialStep2';

export default TutorialStep2;
